import {useTranslation} from 'react-i18next';

import {Box, Grid, SxProps, Typography} from '@mui/material';

import {CultureAnalysisEmptyState} from '../CultureAnalysisEmptyState/CultureAnalysisEmptyState';

import {greenColors, orangeColors} from '../../../../../../layouts/theme/designSystem';
import {RecommendedActions} from '../../types/RecommendedActionsTypes';

interface RecommendedActionCardsProps {
  recommendedActions: RecommendedActions;
}

export default function RecommendedActionCards({recommendedActions}: RecommendedActionCardsProps) {
  const {t} = useTranslation();

  const paperStyles: SxProps = {
    padding: '8px 16px',
    backgroundColor: 'white',
    border: `1px solid ${orangeColors[3]}`,
    boxShadow: 'none',
    borderRadius: '0px 16px 16px 16px',
    width: '100%',
    flexBasis: {xs: '100%', md: '30%'},
  };

  const hasRecommendations = recommendedActions.length > 0;

  const renderRecommendedActionCards = () => {
    return recommendedActions.map((action, index) => (
      <Box key={index} sx={paperStyles} data-testid='recommendation-card'>
        <Typography variant='body1'>{action}</Typography>
      </Box>
    ));
  };

  return (
    <Grid container flexDirection={'column'}>
      <Grid item mt={8} mb={2}>
        <Typography variant='h2' sx={{color: greenColors[700]}}>
          {t('companyCultureDashboard.recommendedActions')}
        </Typography>
      </Grid>
      <Grid
        item
        container
        gap={4}
        display={'grid'}
        gridTemplateColumns={{xs: '1fr', md: 'repeat(3, minmax(min-content, 1fr))'}}
      >
        {hasRecommendations ? (
          renderRecommendedActionCards()
        ) : (
          <Grid item xs={12}>
            <CultureAnalysisEmptyState message={t('companyCultureDashboard.recommendedActionsEmptyState')} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
